import { render, staticRenderFns } from "./BajasCobranza.vue?vue&type=template&id=9fcfc666&"
import script from "./BajasCobranza.vue?vue&type=script&lang=ts&"
export * from "./BajasCobranza.vue?vue&type=script&lang=ts&"
import style0 from "./BajasCobranza.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9fcfc666', component.options)
    } else {
      api.reload('9fcfc666', component.options)
    }
    module.hot.accept("./BajasCobranza.vue?vue&type=template&id=9fcfc666&", function () {
      api.rerender('9fcfc666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasCobranza/BajasCobranza.vue"
export default component.exports